<script setup lang="ts">
import { VueBottomSheet } from '@webzlodimir/vue-bottom-sheet';
import { type BottomSheet } from '@composable/useBottomSheet';
import '@webzlodimir/vue-bottom-sheet/dist/style.css';

const { bottomSheet } = defineProps<{
    bottomSheet: BottomSheet;
}>();

const footerHeight = ref(0);
const title = ref('');

function setRef(ref: any, bottomSheet: BottomSheet) {
    bottomSheet.ref = ref;
}

function setProps(properties: { title: string; footerHeight: number }) {
    footerHeight.value = properties.footerHeight;
    title.value = properties.title;
}
</script>

<template>
    <VueBottomSheet
        :ref="(val: any) => setRef(val, bottomSheet)"
        click-to-close
        max-width="500px"
        max-height="90%"
        overlay-color="rgba(11, 95, 179, 0.3)"
        :style="{
            '--footer-height': `${footerHeight}px`,
            '--title': `'${title}'`,
        }"
        :class="{
            titled: !!title,
            'remove-swipe-header': bottomSheet.attrs?.fullHeight,
        }"
        @closed="bottomSheet.resolve({ reason: 'model' })"
    >
        <component
            :is="bottomSheet.component"
            v-bind="bottomSheet.attrs"
            variant="bottom-sheet"
            @close="
                (arg: any, ...args: any[]) =>
                    bottomSheet.resolve({
                        reason: 'event',
                        args: [arg, ...args],
                    })
            "
            @bottom-sheet-internal-prop-set="setProps"
        />
    </VueBottomSheet>
</template>
<style lang="scss">
.bottom-sheet__backdrop {
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    transition: opacity 200ms;
}

.remove-swipe-header {
    .bottom-sheet__pan {
        display: none !important;
        visibility: hidden !important;
    }
    .bottom-sheet__card {
        border-radius: 0px !important;
    }
    .fx-default {
        height: 100vh;
        min-height: 100vh;
        overflow: hidden;
    }
}

.bottom-sheet__pan {
    flex-shrink: 0;
    height: 24px;
}

.bottom-sheet__card {
    display: flex;
    flex-direction: column;
    padding-left: 4px;
    padding-bottom: var(--footer-height) !important;
}

.bottom-sheet__content {
    flex: 1;
    height: unset !important;
    padding-inline: 12px;
    @include scroll-fantasy;
}

.bottom-sheet {
    opacity: 1 !important;
    transition:
        all 200ms ease,
        visibility 200ms ease 200ms;
    &.opened {
        transition-delay: 0ms;
    }
}

.bottom-sheet.opened .bottom-sheet__backdrop {
    visibility: unset;
    opacity: 1;
    animation: bottom-sheet-enter 0.2 ease !important;
}

.bottom-sheet.closed .bottom-sheet__backdrop {
    visibility: unset;
    opacity: 0;
    animation: bottom-sheet-leave 0.2 ease !important;
}

@keyframes bottom-sheet-enter {
    0% {
        opacity: 0;
        visibility: hidden;
        backdrop-filter: blur(0);
    }
    100% {
        opacity: 1;
        visibility: visible;
        backdrop-filter: blur(10px);
        -webkit-backdrop-filter: blur(10px);
    }
}

@keyframes bottom-sheet-leave {
    0% {
        opacity: 1;
        visibility: visible;
        backdrop-filter: blur(10px);
        -webkit-backdrop-filter: blur(10px);
    }
    100% {
        opacity: 0;
        visibility: hidden;
        backdrop-filter: blur(0);
    }
}

//@include scroll-fantasy;
.titled {
    .bottom-sheet__pan {
        height: 64px;

        &::after {
            content: var(--title);
            width: 100%;
            display: block;
            @include tg-l($w7);
            text-align: center;
            margin-top: 8px;
        }
    }
}

.bottom-sheet_footer {
    width: 100%;
    background-color: white;
    position: fixed;
    bottom: 0;
    padding: 8px;
    margin-right: -12px;
}
</style>
